import { backendAPI } from "../../helper/apis";

// Digitar rotas sem BACKEND_URL, backendAPI ja possui essa URL base
export function getPGP() {
  return backendAPI.get("/pgp");
}

export function savePGP(data) {
  return backendAPI.put("/pgp", data);
}